// extracted by mini-css-extract-plugin
export default {"page":"Login_page__rAf41","authentication":"Login_authentication__KFwAw"};